import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import AdminDashboard from "@/AdminDashboard";
import VibeV2 from "@/VibeV2";
import VibeV3 from "@/VibeV3";
import LandingPage from "@/LandingPage";

const isAdminRoute = window.location.pathname === "/admin" || window.location.pathname.startsWith("/admin/");
const isV2Route = window.location.pathname === "/v2" || window.location.pathname.startsWith("/v2/");
const isV3Route = window.location.pathname === "/v3" || window.location.pathname.startsWith("/v3/");
const isAppRoute = window.location.pathname === "/app" || window.location.pathname.startsWith("/app/");
const isLandingRoute = window.location.pathname === "/" || window.location.pathname === "/landing";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {isAdminRoute ? <AdminDashboard /> : isV3Route ? <VibeV3 /> : isV2Route ? <VibeV2 /> : isLandingRoute ? <LandingPage /> : isAppRoute ? <App /> : <LandingPage />}
  </React.StrictMode>,
);

// Register service worker for PWA (Add to Home Screen support). Disabled for E2E builds so network is mockable.
if (
  process.env.REACT_APP_DISABLE_SW !== "true" &&
  typeof navigator !== "undefined" &&
  "serviceWorker" in navigator
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { updateViaCache: "none" })
      .then((reg) => {
        reg.update();
        console.log("SW registered:", reg.scope);
      })
      .catch((err) => console.log("SW registration failed:", err));
  });
}
